// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/chunks/" + chunkId + "." + {"2113": "5b302d8c9007ab06","4300": "9b620dd5e7e5d068","6374": "9a226d76c97de043","9785": "565bd96b7c7ccde9","9814": "e288baa0e6a8c027",}[chunkId] + ".js"
}